import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BookWidgetStoreKey } from '../../constants/common.constants';
import { BookWidgetStore } from '../../models/states/book-widget-store.interfaces';

const bookWidgetStoreFeatureSelector =
  createFeatureSelector<BookWidgetStore>(BookWidgetStoreKey);

const getFeatureFlagsState = createSelector(
  bookWidgetStoreFeatureSelector,
  (state) => state.featureFlags
);

export const getFeatureFlags = createSelector(
  getFeatureFlagsState,
  ({ featureFlags }) => featureFlags
);
